import type { Editor } from "@tiptap/core";
import type { EditorState } from "@tiptap/pm/state";
import { NodeSelection, TextSelection } from "@tiptap/pm/state";

/** True when the selection is a non-empty text range (not an atom/node). */
export const hasLinkableTextSelection = (state: EditorState) => {
  const { selection } = state;
  if (selection instanceof NodeSelection || selection.empty) {
    return false;
  }
  if (!(selection instanceof TextSelection)) {
    return false;
  }
  return (
    state.doc.textBetween(selection.from, selection.to, " ").trim().length > 0
  );
};

export const shouldShowLinkSection = (
  editor: Editor,
  state: EditorState,
  { requireFocus = true }: { requireFocus?: boolean } = {},
) => {
  if (editor.isDestroyed || !editor.isEditable) {
    return false;
  }
  // TipTap's default BubbleMenu checks focus; custom shouldShow must do the
  // same. Without it, a leading link keeps the initial selection inside the
  // mark and the toolbar appears even when the editor is blurred.
  if (requireFocus && !editor.isFocused) {
    return false;
  }
  return editor.isActive("link") || hasLinkableTextSelection(state);
};

export const shouldShowFileSection = (
  editor: Editor,
  _state: EditorState,
  { requireFocus = true }: { requireFocus?: boolean } = {},
) => {
  if (editor.isDestroyed || !editor.isEditable) {
    return false;
  }
  if (requireFocus && !editor.isFocused) {
    return false;
  }
  return editor.isActive("file");
};

export const shouldShowTableSection = (
  editor: Editor,
  { requireFocus = true }: { requireFocus?: boolean } = {},
) => {
  if (editor.isDestroyed || !editor.isEditable) {
    return false;
  }
  if (requireFocus && !editor.isFocused) {
    return false;
  }
  return editor.isActive("table");
};
